<template>
	<div class="v-editable" :class="vEditableClasses" @click="editfieldarea">
		<button v-if="!saveing && !loading && can_edit" tabindex="-1" class="st-edit-btn" @click="editfield">
			<i v-if="active_field == false || active_field.fieldname != fieldname" class="fa" :class="'fa-' + icon" aria-hidden="true"></i>
			<i v-else class="fa fa-ban" aria-hidden="true"></i>
		</button>

		<v-field
            v-if="active_field.fieldname == fieldname && inline"
			:inline="inline"

            :chart="chart"
            :name="fieldname"
            @cancel="$store.commit('RESET_ACTIVE_FIELD')"
        ></v-field>
		<slot slot-scope="field" :field="field" v-else></slot>
	</div>
</template>

<script>
export default {
	name: 'v-editable',
	props: {
		inline: {
			type: Boolean,
			default(){
				return this.$store.getters['features/inlinemod'];
			}
		},
		chartid: {
			default: false
		},
		fieldname: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: 'pencil'
		},
		disabled: {
			type: String,
			default: ''
		},
		areaedit: {
			type: Boolean,
			default: true
		},
	},
	computed: {
	  	chart(){
	  		return this.$store.getters.getChartById(this.chartid);
	  	},
		field(){
	  		return this.$store.getters.getChartField(this.chartid, this.fieldname);
	  	},

		active_field(){
			return this.$store.getters.active_field;
		},

	  	can_edit(){
	  		if (this.chart.id <= 0) return false;
	  		return this.field && this.field.permissions ? this.field.permissions.can_edit : false;
	  	},

		vEditableClasses(){
			const field = this.field,
				  active_field = this.active_field;

			return {
				'editable' : this.can_edit,
				'v-editable--inline' : this.$store.getters['features/inlinemod'],
				'v-editable--disabled' : this.disabled.length > 0,
				'editable--active': active_field && active_field.fieldname == this.fieldname
			};
		},

		saveing(){
			return this.$store.getters.saveing;
		},

		loading(){
			return this.$store.getters.loading;
		},
	},
	methods: {
		editfieldarea(event){
			if(!this.can_edit) return;
			if(this.inline && this.active_field.fieldname == this.fieldname) return;

			if(!this.field.permissions.can_edit) return;
			if(this.areaedit){ this.trigger(); }
		},
		editfield(event){
			if(!this.field.permissions.can_edit) return;
			if(!this.areaedit){ this.trigger(); }
		},

		trigger(){
			if(this.active_field.fieldname == this.fieldname ){
				this.$store.commit('RESET_ACTIVE_FIELD');
			} else {
				this.$store.commit('SET_ACTIVE_FIELD', {
					fieldname: this.fieldname,
					element: this.$el,
					chartid: this.chartid
				});

			}
		}
	}
}
</script>

<style lang="scss">
.v-editable,
.editable {
	z-index: 100;
}
.v-editable--inline {
	width: 100%;
}
.contact-element .v-editable {
	min-height: 50px;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/v-editable.vue